import { useAgency } from 'context/agency'
import React from 'react'
import { Link } from 'react-router-dom'

function AppLogo() {
  const { agency } = useAgency()
  return (
    <Link to={'/'}>
      <img src={agency?.scanner_config?.logo} alt='logo' width={'30px'} />
    </Link>
  )
}

export default AppLogo
